import { locationsUrl, locationsPersonalisedSuggestUrl } from 'config';
import { log } from 'logger';
import createRequest from '../create-request';

const request = createRequest({ label: 'locations' });

const suggest = query => {
  log.info({ params: query }, `Calling ${locationsUrl}`);

  const locationsPromise = request
    .get(locationsUrl)
    .query(query)
    .accept('application/json')
    .type('application/json')
    .then(({ body: suggestions }) => {
      if (ENV.SERVER) {
        return suggestions; // What is this for??
      }

      if (suggestions.international.length === 0) {
        return [{
          suggestions: suggestions.local
        }];
      }

      if (suggestions.local.length === 0) {
        return [{
          suggestions: suggestions.international
        }];
      }

      return [
        {
          suggestions: suggestions.local
        },
        {
          sectionName: 'INTERNATIONAL',
          suggestions: suggestions.international
        }
      ];
    });

  return locationsPromise;
};

const personalisedSuggest = query => {
  log.info({}, `Calling ${locationsPersonalisedSuggestUrl}`);

  return request
    .get(locationsPersonalisedSuggestUrl)
    .query(query)
    .accept('application/json')
    .type('application/json')
    .then(response => response.body);
};

export default {
  suggest,
  personalisedSuggest
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/seek-jobs-api-client/apis/locations.js
 **/